__turbopack_context__.v({
  "columnEditor": "ColumnEditor-module__zm94nq__columnEditor",
  "droppableContainer": "ColumnEditor-module__zm94nq__droppableContainer",
});
